import { CurrentUser } from '@/hooks/useCurrentUser';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TokenState {
  originalToken: string | null;
  originalUser: CurrentUser | null;
  isImpersonating: boolean;
}

const initialState: TokenState = {
  originalToken: null,
  originalUser: null,
  isImpersonating: false,
};

interface SetImpersonationPayload {
  token: string;
  user: CurrentUser;
}

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setImpersonation(state, action: PayloadAction<SetImpersonationPayload>) {
      state.originalToken = action.payload.token;
      state.originalUser = action.payload.user;
    },
    setImpersonationFalg(state) {
      state.isImpersonating = true;
    },
    clearImpersonation(state) {
      state.originalToken = null;
      state.originalUser = null;
      state.isImpersonating = false;
    },
  },
});

export const { setImpersonation, clearImpersonation, setImpersonationFalg } = tokenSlice.actions;
export default tokenSlice.reducer;
